export const examAdminAuth = {
  login: {
    pageTitle: "管理ログイン",
    documentTitle: "{platformName} · 管理ログイン",
    shellSubtitle: "AI Exam 管理ポータル",
    portalLabel: "管理入口",
    title: "{platformName} にログイン",
    shellDescriptionSso:
      "統一認証でのログインを優先します。ポータルから遷移した場合、このページが現在のセッションを自動的に引き継ぎます。",
    shellDescriptionHybrid:
      "統一認証とローカルアカウントログインの両方を利用できます。統一認証を推奨します。",
    shellDescriptionLocal:
      "このインスタンスでは現在ローカルログインのみ利用できます。ローカルアカウントで管理画面へ入ってください。",
    devAccounts: "利用可能なローカルアカウント：{accounts}",
    maintenanceNotice:
      "サイトはメンテナンス中です。受験側は利用できませんが、管理者は保守のためログインできます。",
    noPortalAccess: "このアカウントには管理画面のアクセス権限がありません",
    noResolvedSsoSession: "利用可能な統一認証セッションがありません",
    captchaRequired: "先に認証コードを入力してください",
    refreshCaptcha: "認証コードを更新",
    ipNotAllowed: "IP は許可範囲外です",
    submit: "ログイン",
    authSourceLabel: "ログイン方式",
    authSourceHintHybrid: "現在はローカルログインと統一認証ログインの両方を利用できます。",
    authSourceHintSso: "管理ポータルは統一認証ログインへ切り替わっています。",
    authSourceHintLocal: "このインスタンスでは現在ローカルログインのみ利用できます。",
    bootstrapCheckingTitle: "統一認証ログイン状態を確認中...",
    bootstrapCheckingDescription: "ポータルから入った場合、このページは自動的にスキップされます。",
    currentUnifiedIdentityTitle: "現在の統一認証",
    currentUnifiedIdentityDescription: "統一認証でログインすると、そのまま管理ポータルへ入れます。",
    resolvedSsoUserDescription:
      "現在の統一認証セッションが見つかりました。管理ポータルへすぐ入れます。",
    resolvedSsoUsernameLabel: "統一認証アカウント",
    resolvedSsoRoleLabel: "ロール",
    enterWithResolvedSsoUser: "現在の認証で入る",
    noResolvedSsoSessionTitle: "統一認証セッションが見つかりません",
    noResolvedSsoSessionDescription:
      "先にポータルからログインするか、統一認証センターが利用可能か確認してください。",
    openPortal: "ポータルを開く",
    openCandidatePortal: "受験側を開く",
    highlightUnifiedEntry: "統一された管理入口",
    highlightRoleAccess: "ロールベースアクセス制御",
    highlightMaintainable: "保守しやすい運用",
  },
  changePassword: {
    sectionLabel: "セキュリティポリシー",
    title: "ログインパスワード変更",
    description: "アカウント {username} は管理画面を使い続ける前にパスワード変更が必要です。",
    success: "パスワードを変更しました",
    mismatch: "新しいパスワードが一致しません",
    newPasswordMustDiffer: "新しいパスワードは現在のパスワードと異なる必要があります",
    submit: "新しいパスワードを保存",
    highlightUnifiedShell: "統一認証シェル",
    highlightPolicy: "パスワードポリシー適用",
    highlightSession: "現在のセッション同期",
  },
};
